import {
  CameraFilledIcon,
  CaretRightIcon,
  CheckmarkCircleFilledIcon,
  TimeFilledIcon,
} from '@calizahq/react-components-v2'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { BottomSheet, History } from '@/components'
import { RecordType } from '@/graphql/queries/fieldHistoryLogs/fieldHistoryLogs.queries'
import { useToggle } from '@/hooks'
import { HomeQualityCheckStatus, HomeQualityCheckSummary } from '@/types/HomeQualityCheck'
import { formatDate } from '@/util'

import { HomeQualityCheckSummaryMedia } from './Media'

export const HomeQualityCheckSummaryListColumns = (setHomeQualityCheckId: (homeQualityCheckId?: number) => void) => {
  return [
    {
      Header: 'Previous Reservation',
      accessor: 'precedingReservationId',
      width: 75,
      Cell: function CellRenderer({ row }: { row: { original: HomeQualityCheckSummary } }) {
        const { precedingReservationId, precedingReservationMoveOutDate } = row.original
        const navigate = useNavigate()

        return (
          <>
            <p
              className="cursor-pointer leading-120 text-primary hover:underline"
              onClick={() => navigate(`/reservations/${precedingReservationId}`)}
              role="presentation"
            >
              {`Move-out: ${
                precedingReservationMoveOutDate
                  ? formatDate(new Date(precedingReservationMoveOutDate || ''), 'MM-dd-yyyy')
                  : 'Pending'
              }`}
            </p>
          </>
        )
      },
    },
    {
      Header: 'Upcoming Reservation',
      accessor: 'upcomingReservationId',
      width: 75,
      Cell: function CellRenderer({ row }: { row: { original: HomeQualityCheckSummary } }) {
        const { upcomingReservationId, upcomingReservationMoveInDate } = row.original
        const navigate = useNavigate()

        return (
          <>
            {upcomingReservationId ? (
              <p
                className="cursor-pointer leading-120 text-primary hover:underline"
                onClick={() => navigate(`/reservations/${upcomingReservationId}`)}
                role="presentation"
              >
                {`Move-in: ${
                  upcomingReservationMoveInDate
                    ? formatDate(new Date(upcomingReservationMoveInDate || ''), 'MM-dd-yyyy')
                    : 'N/A'
                }`}
              </p>
            ) : (
              <p className="leading-120 text-primary">Move-in: N/A</p>
            )}
          </>
        )
      },
    },
    {
      Header: 'Notes',
      accessor: 'notes',
      width: 100,
    },
    {
      Header: 'Actions',
      accessor: 'id',
      width: 45,
      Cell: function CellRenderer({ row }: { row: { original: HomeQualityCheckSummary } }) {
        const { id, status } = row.original
        const { isShown: historyModalShown, toggle: historyModalToggle } = useToggle()
        const { isShown: mediaModalShown, toggle: mediaModalToggle } = useToggle()

        return (
          <>
            {status ? (
              status === HomeQualityCheckStatus.NOT_READY ? (
                <button
                  className={'ml-2 mr-2 grid h-5 w-5 items-center justify-center'}
                  onClick={() => setHomeQualityCheckId(id)}
                  title="Continue Inspection"
                >
                  <CaretRightIcon className="w-5 cursor-pointer icon-tertiary" />
                </button>
              ) : (
                <div title="Home marked as Ready">
                  <CheckmarkCircleFilledIcon className="h-5 text-green-300" />
                </div>
              )
            ) : null}
            <button
              className={'ml-2 mr-2 grid h-5 w-5 items-center justify-center'}
              onClick={historyModalToggle}
              title="View History"
            >
              <TimeFilledIcon className="w-5 cursor-pointer icon-tertiary" />
            </button>
            {row.original.attachments && row.original.attachments.length > 0 ? (
              <button
                className={'ml-2 mr-2 grid h-5 w-5 items-center justify-center'}
                onClick={mediaModalToggle}
                title="View Media"
              >
                <CameraFilledIcon className="w-5 cursor-pointer icon-tertiary" />
              </button>
            ) : null}

            {historyModalShown ? (
              <BottomSheet isVisible={historyModalShown} mobileFullHeight={true} onClose={historyModalToggle}>
                <History recordId={id} recordType={RecordType.HOME_QUALITY_CHECKS} />
              </BottomSheet>
            ) : null}

            {mediaModalShown && row.original.attachments && row.original.attachments.length > 0 ? (
              <BottomSheet header="Media" isVisible={mediaModalShown} onClose={mediaModalToggle}>
                <HomeQualityCheckSummaryMedia attachments={row.original.attachments} />
              </BottomSheet>
            ) : null}
          </>
        )
      },
    },
  ]
}
